import { createSlice } from '@reduxjs/toolkit';
import { fetchPopupNotification } from './Utils/PopupNotificationUtils';

const popupNotificationSlice = createSlice({
  name: 'PopupNotification',
  initialState: {
    filters: {
      'filter[id]': '',
      'filter[target_page]': '',
      'filter[is_show]': '',
      'sort': '',
      'page': 1,
    },
    data: [],
    detail: {},
    isLoading: false,
  },
  reducers: {
    setFilters: (state, action) => {
      state.filters = action.payload;
    },
    setData: (state, action) => {
      state.data = action.payload;
    },
    setDetail: (state, action) => {
      state.detail = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchPopupNotification.pending, (state) => {
        // Handle loading state
        state.isLoading = true;
      })
      .addCase(fetchPopupNotification.fulfilled, (state, action) => {
        // Handle success state
        state.data = action.payload;
        state.isLoading = false;
      })
      .addCase(fetchPopupNotification.rejected, (state, action) => {
        // Handle error state
        state.isLoading = false;
        console.log(action.error.message, "error action")
      });
  }
});

export const { setFilters, setData, setDetail } = popupNotificationSlice.actions;

export default popupNotificationSlice.reducer;